import "./themes/next-level-mission-nucont.scss";
import "./themes/next-level-mission-nucont-dark.scss";
import { ConfettiAnimation } from "../../../../../../presentation/services/ConfettiAnimation/ConfettiAnimation";
import oneMillionShareDialogTemplate from "../../../../../../shared/dialogs/one-million-share/one-million-share-dialog.html";

export class NextTheLevelMissionNucontDialogCtrl {
    ConfettiAnimation = new ConfettiAnimation();
    statusImpact = {
        Bronze: "bronze",
        Prata: "silver",
        Ouro: "Prata",
        Embaixador: "ambassador"
    };

    statusColorFireworks = {
        Bronze: "#B500D9",
        Prata: "#00D2D9",
        Ouro: "#FFB700"
    };

    nextCurrentImpactLevel = null;

    constructor($mdDialog, DSNDialogService, locals, $state) {
        this.$mdDialog = $mdDialog;
        this.DSNDialogService = DSNDialogService;
        this.locals = locals;
        this.$state = $state;
    }

    $onInit() {
        this.ConfettiAnimation.fireworks({
            colors: [
                this.statusColorFireworks[
                    this.locals?.engagement?.nextImpactLevel?.status || "Bronze"
                ]
            ],
            zIndex: 1000
        });
    }

    onOpenPrintNextLevel() {
        this.$mdDialog.cancel();

        this.DSNDialogService.custom({
            controller: "OneMillionShareDialogCtrl as $ctrl",
            clickOutsideToClose: true,
            locals: {
                accountingData: this.locals.accountingData,
                isLevelUp: true,
                status:
                    this.locals?.engagement?.nextImpactLevel?.status?.toLowerCase() ||
                    "bronze",
                width: "auto",
                title: "Compartilhe a Missão",
                templateHtml: oneMillionShareDialogTemplate
            },
            after: {
                cancel: () => {},
                hide: () => {}
            }
        });
    }

    onDetails() {
        this.$mdDialog.cancel();

        const href = this.$state.href(
            "nucont.accounting.reporting-center.generateds",
            {
                progressLevelSideNav: true
            }
        );

        window.open(href, "_blank");
    }
}

angular
    .module("nucont")
    .controller("NextTheLevelMissionNucontDialogCtrl", [
        "$mdDialog",
        "DSNDialogService",
        "locals",
        "$state",
        NextTheLevelMissionNucontDialogCtrl
    ]);
